/* eslint-disable no-unused-vars */
const { getAppDispatch } = require('@utilities/dispatch.util');
const { tasksListsActions } = require('@redux/slices/tasks');
const { inspectionActions } = require('@redux/slices/inspection');
const { checkActions } = require('@redux/slices/checks');

const storeDataInRedux = ({ manipulationJson, apisList, apisListMap }) => {
  return new Promise((resolve, reject) => {
    try {
      const dispatch = getAppDispatch();

      const manipulationJsonKeys = Object.keys(manipulationJson);

      for (let indexString in manipulationJsonKeys) {
        const index = parseInt(indexString);

        const currentKey = manipulationJsonKeys[index];

        const currentAPIResponseData = manipulationJson[currentKey];

        apisListMap[currentKey];

        const dispatcher = apisList[apisListMap[currentKey]]?.dispatcher || null;
        if (dispatcher) {
          dispatcher({
            data: currentAPIResponseData
          });
        } else {
          if (currentKey === 'WorkOrderCache/SyncedWorkOrderCache') {
            dispatch?.(tasksListsActions.setTasksListNew(currentAPIResponseData || []));
          } else if (currentKey === 'AssignedAssetCheckCache/SyncedAssetCheckCache') {
            dispatch?.(checkActions.setChecksListNew(currentAPIResponseData || []));
          } else if (currentKey === 'InspectionCache/SyncedInspectionCache') {
            dispatch?.(inspectionActions.setInspectionListNew(currentAPIResponseData || []));
          }
        }
      }

      resolve('All data set in redux');
    } catch (error) {
      console.log({ error });
      reject({ error: 'error' });
    }
  });
};

export { storeDataInRedux };
